<template>
  <div id="app">
  
   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style src="@/assets/css/style.css"></style>
<style src="@/assets/css/common.css"></style>




// WEBPACK FOOTER //
// app.vue